/**
 * Censo por capa del visor DWG/DXF. Una capa se mide como el lector (`plano2svg.py`): solo su
 * geometría SUELTA; los INSERT (bloques) de esa capa van aparte, por nombre de bloque.
 * Por eso `porCapaSuelta` no incluye las inserciones: elegir/resaltar una capa no marca sus muebles.
 */
export interface EntidadDelCenso {
  handle: string;
  capa: string;
  esBloque: boolean;
}

export interface CensoDeCapas {
  /** capa → handles de geometría suelta (sin INSERT). Es lo que mide el lector. */
  porCapaSuelta: Map<string, string[]>;
  /** Todas las capas que tienen alguna entidad (aunque solo tengan bloques). */
  capasConEntidades: string[];
}

export function armarCensoDeCapas(entidades: Iterable<EntidadDelCenso>): CensoDeCapas {
  const porCapaSuelta = new Map<string, string[]>();
  const todas = new Set<string>();
  for (const e of entidades) {
    todas.add(e.capa);
    if (e.esBloque) continue;
    const arr = porCapaSuelta.get(e.capa);
    if (arr) arr.push(e.handle);
    else porCapaSuelta.set(e.capa, [e.handle]);
  }
  return { porCapaSuelta, capasConEntidades: [...todas] };
}
